// Flip SIGNUP_ENABLED to true when you're ready to go live.
// When false: all CTAs read "Coming soon" and do nothing.
// When true:  all CTAs read "Sign up now" and open the signup form.
export const SIGNUP_ENABLED = true;

export const CTA_LABEL = SIGNUP_ENABLED ? "Sign up now" : "Coming soon";
